<template lang="pug">
.gym-submitted
  h2.gym-submitted-header {{ __('Your gym has been submitted') }}
  Icon.gym-submitted-icon(name="check" fill="white")
  p.gym-submitted-text {{__('Your submission is under review. Once approved, you can find your gym on the Rogue Equipped Gyms Map.')}}
</template>
<script setup lang="ts">

</script>
<style lang="scss" scoped>
.gym-submitted {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  &-header, &-text {
    margin: 0;
    text-align: center;
  }

  &-icon {
    background-color: $color-green;
    border-radius: $space-m;
    height: $size-xxxxl;
    margin: $space-s auto;
    padding: $space-xxs;
    width: $size-xxxxl;
  }

  &-text {
    font-size: $size-xs;
  }
}
</style>
